import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Start from './views/1-Start';
import Topics from './views/2-Topics';
import Statement from './views/3-Statement';
import Summary from './views/4-Summary';

var siteurl = 'https://autismiliitto.local';
if (window.eautismiliittoVariables && window.eautismiliittoVariables.siteurl) {
  siteurl = window.eautismiliittoVariables.siteurl;
}

var basename = '/';
if (window.eautismiliittoVariables && window.eautismiliittoVariables.baseurl) {
  basename = window.eautismiliittoVariables.baseurl;
}

var nonce = false;
if (window.eautismiliittoVariables && window.eautismiliittoVariables.nonce) {
  nonce = window.eautismiliittoVariables.nonce;
}

var selko = false;
if (window.eautismiliittoVariables && window.eautismiliittoVariables.selko) {
  selko = window.eautismiliittoVariables.selko;
}

var lang = 'fi';
if (window.eautismiliittoVariables && window.eautismiliittoVariables.lang) {
  lang = window.eautismiliittoVariables.lang;
}

function App() {
  const [topics, setTopics] = useState([]);
  const [texts, setTexts] = useState([]);

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      const headers = new Headers();
      if ( nonce ) {
        headers.append('X-WP-Nonce', nonce);
      }
      const response = await fetch(siteurl + '/wp-json/pwd-eautismiliitto/v1/data?selko=' + selko + '&lang=' + lang, {
          method: 'GET',
          headers: headers
      });
      const data = await response.json();
      setTopics(data.posts);
      setTexts(data.texts);
    };

    fetchData();
  }, []);

  return (
    <>
      <Router basename={basename}>
        <Routes>
          <Route exact path="/" element={<Start texts={texts} />} />
          <Route path="/topics" element={<Topics topics={topics} texts={texts} />} />
          <Route path="/statement/:topicId/:statementId" element={<Statement topics={topics} texts={texts} />} />
          <Route path="/summary/:topicId" element={<Summary topics={topics} texts={texts} />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
